module.exports = __webpack_public_path__ + "img/流体力学3_3.47465bb2.jpg";